// src/components/Footer.jsx
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaClock } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-green-700 text-white mt-12">
      <div className="max-w-6xl mx-auto px-6 py-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 text-sm">
        {/* Address */}
        <div className="flex items-start gap-3">
          <FaMapMarkerAlt className="mt-1 text-green-100" />
          <div>
            <h4 className="font-semibold mb-1">Clinic Address</h4>
            Shop No- G-3, Udai Nagar,<br />
            Near Elite Anmol Apartment, Indore
          </div>
        </div>

        {/* Contact */}
        <div className="flex items-start gap-3">
          <FaPhoneAlt className="mt-1 text-green-100" />
          <div>
            <h4 className="font-semibold mb-1">Contact</h4>
            <a href="tel:+918319789552" className="hover:underline block">
              +91 83197 89552
            </a>
            <a href="mailto:drnidhimalviya19@gmail.com" className="hover:underline">
              drnidhimalviya19@gmail.com
            </a>
          </div>
        </div>

        {/* Timings */}
        <div className="flex items-start gap-3">
          <FaClock className="mt-1 text-green-100" />
          <div>
            <h4 className="font-semibold mb-1">Clinic Hours</h4>
            Mon–Sat: 10 AM – 1 PM, 5 PM – 8 PM<br />
            Sunday: 10 AM – 1 PM
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-green-800 text-center py-3 text-xs sm:text-sm">
        &copy; {new Date().getFullYear()} Aarogyam Homoeopathic Clinic. All rights reserved.
      </div>
    </footer>
  );
}
